import React, { useState } from 'react';
import { Menu } from 'lucide-react';
import { Sidebar } from './components/Sidebar';
import { ExecutiveSummary } from './components/ExecutiveSummary';
import { Layer1DataIngestion } from './components/Layer1DataIngestion';
import { Layer2FeatureEngineering } from './components/Layer2FeatureEngineering';
import { Layer3EligibilityGates } from './components/Layer3EligibilityGates';
import { Layer4Scorecard } from './components/Layer4Scorecard';
import { Layer5LoanSizing } from './components/Layer5LoanSizing';
import { Layer6Monitoring } from './components/Layer6Monitoring';
import { BankInterface } from './components/BankInterface';
import { InteractiveCalculator } from './components/InteractiveCalculator';
import { IntegrationsLayer } from './components/IntegrationsLayer';
import { MerchantInterface } from './components/MerchantInterface';
export function App() {
  const [activeSection, setActiveSection] = useState('exec-summary');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const renderContent = () => {
    switch (activeSection) {
      case 'exec-summary':
        return <ExecutiveSummary data-id="element-0" />;
      case 'layer-1':
        return <Layer1DataIngestion data-id="element-1" />;
      case 'layer-2':
        return <Layer2FeatureEngineering data-id="element-2" />;
      case 'layer-3':
        return <Layer3EligibilityGates data-id="element-3" />;
      case 'layer-4':
        return <Layer4Scorecard data-id="element-4" />;
      case 'layer-5':
        return <Layer5LoanSizing data-id="element-5" />;
      case 'layer-6':
        return <Layer6Monitoring data-id="element-6" />;
      case 'integrations':
        return <IntegrationsLayer data-id="element-7" />;
      case 'merchant':
        return <MerchantInterface data-id="element-8" />;
      case 'bank-interface':
        return <BankInterface data-id="element-9" />;
      case 'calculator':
        return <InteractiveCalculator data-id="element-10" />;
      default:
        return <ExecutiveSummary data-id="element-11" />;
    }
  };
  return <div className="min-h-screen bg-slate-50 flex" data-id="element-12">
      <Sidebar activeSection={activeSection} setActiveSection={setActiveSection} isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} data-id="element-13" />

      <div className="flex-1 lg:ml-72 flex flex-col min-h-screen" data-id="element-14">
        {/* Mobile Header */}
        <div className="lg:hidden bg-white border-b border-slate-200 p-4 flex items-center justify-between sticky top-0 z-30" data-id="element-15">
          <div className="flex items-center gap-2" data-id="element-16">
            <img src="https://cdn.magicpatterns.com/uploads/jwMNkiJLrVq1yMSnmJbDKf/GB50000000003972079.jpg" alt="Pomelo" className="w-7 h-7 rounded-md object-cover" data-id="element-17" />
            <div className="font-semibold text-slate-900 text-sm" data-id="element-18">
              Pomelo SME Lending
            </div>
          </div>
          <button onClick={() => setIsSidebarOpen(true)} className="p-2 text-slate-500 hover:bg-slate-100 rounded-lg" data-id="element-19">
            <Menu className="w-5 h-5" data-id="element-20" />
          </button>
        </div>

        <main className="flex-1 overflow-x-hidden" data-id="element-21">{renderContent()}</main>
      </div>
    </div>;
}